import { CmpsInsightCoachingPerformanceData } from '@cmps/ng-kit';

import { PayloadAction } from '../../store.model';
import { ActionType, SelectActionAction } from '../my-performance-card.action';
import { PerformanceCardState } from '../my-performance-card.state';

function updateProgressBarData(
    progressBars: CmpsInsightCoachingPerformanceData[] = [],
    colorGroup: string,
    allProgressEnabled?: boolean,
): CmpsInsightCoachingPerformanceData[] {
    if (allProgressEnabled === true) {
        return progressBars.map((progress) => ({
            ...progress,
            enabled: true,
        }));
    }
    const isEnabledAndAlone =
        progressBars.filter((p) => p.enabled).length === 1 &&
        progressBars.some((p) => p.backgroundColor === colorGroup && p.enabled);

    return progressBars.map((progress) => {
        const matchesColor = progress.backgroundColor === colorGroup;
        if (isEnabledAndAlone) {
            return {
                ...progress,
                enabled: true,
            };
        } else {
            return {
                ...progress,
                enabled: matchesColor,
            };
        }
    });
}

export const handleSelectPillarResult = (
    state: PerformanceCardState,
    action: PayloadAction<
        ActionType.MY_PERFORMANCE_CARD_SELECT_PILLAR_ACTION,
        SelectActionAction
    >,
): PerformanceCardState => {
    const { userId, isParentPillar, colorGroup } = action.payload;
    const user = state.userData?.[userId];

    if (user == null || isParentPillar == null) {
        return state;
    }

    const updatedTotalPillar = {
        ...user.totalPerformancePillar,
        parentPillar: {
            ...user.totalPerformancePillar?.parentPillar,
            progressBarData: updateProgressBarData(
                user.totalPerformancePillar?.parentPillar?.progressBarData,
                colorGroup,
            ),
        },
    };

    const allProgressEnabled =
        updatedTotalPillar.parentPillar.progressBarData.every(
            (progress) => progress.enabled,
        );

    const updatedPillarsData = (user.pillarsData ?? []).map((pillar) => {
        const childPillarsUpdated = pillar.childPillars.map((childPillar) => {
            let isVisible = false;

            if (
                childPillar.color?.toLowerCase() === '#000000' &&
                colorGroup?.toLowerCase() === '#bababa'
            ) {
                isVisible = true;
            } else {
                isVisible =
                    allProgressEnabled ||
                    childPillar.color?.toLowerCase() ===
                        colorGroup?.toLowerCase();
            }

            return { ...childPillar, isVisible };
        });

        const anyChildVisible = childPillarsUpdated.some(
            (child) => child.isVisible,
        );

        return {
            ...pillar,
            isCollapsed: allProgressEnabled ? false : anyChildVisible,
            parentPillar: {
                ...pillar.parentPillar,
                progressBarData: updateProgressBarData(
                    pillar.parentPillar.progressBarData,
                    colorGroup,
                    allProgressEnabled,
                ),
            },
            childPillars: childPillarsUpdated,
        };
    });

    return {
        ...state,
        userData: {
            ...state.userData,
            [userId]: {
                ...user,
                totalPerformancePillar: updatedTotalPillar,
                pillarsData: updatedPillarsData,
            },
        },
    };
};
